export const loyaltyProgramConstants = {
  SET_LOYALTY_PROGRAMS_LOADING: 'loyaltyProgram/SET_LOYALTY_PROGRAMS_LOADING',
  GET_LOYALTY_PROGRAMS: 'loyaltyProgram/GET_LOYALTY_PROGRAMS',
  SET_LOYALTY_PROGRAMS: 'loyaltyProgram/SET_LOYALTY_PROGRAMS',
  CLEAR_LOYALTY_PROGRAMS: 'loyaltyProgram/CLEAR_LOYALTY_PROGRAMS',
  ADD_LOYALTY_PROGRAM: 'loyaltyProgram/ADD_LOYALTY_PROGRAM',
  GET_LOYALTY_PROGRAM: 'loyaltyProgram/GET_LOYALTY_PROGRAM',
  SET_LOYALTY_PROGRAM: 'loyaltyProgram/SET_LOYALTY_PROGRAM',
  EDIT_LOYALTY_PROGRAM: 'loyaltyProgram/EDIT_LOYALTY_PROGRAM',
  DELETE_LOYALTY_PROGRAM: 'loyaltyProgram/DELETE_LOYALTY_PROGRAM',
};
